module.exports = __webpack_public_path__ + "static/media/interactivo1.4d671a77.png";